import React from 'react';
import { Star, Calendar, ArrowRight } from 'lucide-react';

const NieuwsPage = () => {
  const nieuwsArtikelen = [
    {
      title: "Nederland lot in poule A bij WK 2026",
      excerpt: "Oranje begint aan WK-campagne tegen Mexico op 14 juni in Los Angeles.",
      category: 'Lotingsceremonie',
      date: '29 maart 2026'
    },
    {
      title: "Deze stadions hosten WK-wedstrijden",
      excerpt: "Van New York tot Los Angeles: dit zijn de 16 stadions waar het WK wordt gespeeld.",
      category: 'Stadions',
      date: '28 maart 2026'
    },
    {
      title: "WK 2026: Dit zijn de favorieten",
      excerpt: "Brazilië, Argentinië, Frankrijk en Nederland horen bij de topfavorieten.",
      category: 'Analyse',
      date: '27 maart 2026'
    }
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-amber-600 to-orange-600 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Nieuws</h1>
          <p className="text-xl opacity-90">Laatste nieuws en updates over het WK 2026</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {nieuwsArtikelen.map((artikel, index) => (
              <article key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition">
                <img src={`https://picsum.photos/seed/wkn${index}/400/200`} alt="Nieuws" className="w-full h-48 object-cover" />
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <span className="bg-amber-100 text-amber-800 px-3 py-1 rounded-full font-semibold mr-3">
                      {artikel.category}
                    </span>
                    {artikel.date}
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-gray-800">{artikel.title}</h3>
                  <p className="text-gray-600 mb-4">{artikel.excerpt}</p>
                  <button className="text-amber-600 font-semibold hover:text-amber-800 flex items-center">
                    Lees meer <ArrowRight className="ml-2" size={18} />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default NieuwsPage;